import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';


import * as Common from '../Common';
import Dialog from '../Dialog';
import InwardView from './InwardView';

function InwardCover(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [rightInwardCoverFinal, setRightInwardCoverFinal] = useState([]);

    const [inwardDetail, setInwardDetail] = useState([]);
    const [coverListData, setCoverListData] = useState([]);
    const [reqHeader, setReqHeader] = useState([]);

    const [reqDealId, setReqDealId] = useState("");
    const [reqDealRate, setReqDealRate] = useState("");
    const [reqDealValue, setReqDealValue] = useState("");
    const [reqDealValueDate, setReqDealValueDate] = useState(new Date());

    const [reqTenure, setReqTenure] = useState("TOM");

    const [totalCover, setTotalCover] = useState(0);
    const [totalCoverInr, setTotalCoverInr] = useState(0);
    const [avgCoverRate, setAvgCoverRate] = useState(0);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'INWARDCOVERFINAL'], function (result) {
                let resp = JSON.parse(result);

                setRightInwardCoverFinal(resp);
                if (resp.query === "1") {
                    Common.callApi(Common.apiInward, [sid, 'getdetail', props.srno], function (result) {
                        let resp = JSON.parse(result);

                        if (resp.status === "MSG0002") {
                            navigate('/');
                        }
                        $('.loader').hide();

                        setInwardDetail(resp);
                        setCoverListData(resp.cover);
                        calcTotalCover(resp.cover, resp.data[0]);
                        setReqHeader(resp.data[0]);
                        onchangeReqTenure(reqTenure);
                        setRefreshCounter(refreshCounter + 1);
                    });
                } else {
                    navigate('/'); // no query right
                }
            });

            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function btnBackClick() {
        props.callInProgress();
    }

    function calcTotalCover(nv, header) {
        let tc = 0;
        let tcinr = 0;
        for (var i = 0; i < nv.length; i++) {
            tc = tc * 1 + (nv[i].tric_value) * 1;
            tcinr = ((1 * (nv[i].tric_value * 1) * (nv[i].tric_rate * 1)) + 1 * tcinr).toFixed(2);

            console.log(tcinr);

        }
        setTotalCover(tc.toFixed(2));
        setTotalCoverInr(tcinr);
        setAvgCoverRate((1 * tcinr / tc).toFixed(2));
        // setReqDealValue((header.reqi_branchreprocessquantity - header.reqi_quantity) - tc);
    }

    function btnCoverFinal() {
        $('.loader').show();
        var obj = {
            srno: props.srno,
        }
        Common.callApi(Common.apiInward, [sid, 'coverfinal', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);

            if (resp.err === "") {
                setInwardDetail(resp);
                setCoverListData(resp.cover);
                calcTotalCover(resp.cover, resp.data[0]);
                setReqHeader(resp.data[0]);
                setReqDealId("");
                setReqDealRate("");
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }


            $('.loader').hide();
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function btnAddCoverClick() {

        $('.loader').show();
        var isOk = 0;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        if (reqDealId === "" || reqDealRate === "" || reqDealValue === "") {
            msg[i++] = (reqDealId === "" ? " Deal Id " : '');
            msg[i++] = (reqDealRate === "" ? " Deal Rate " : '');
            msg[i++] = (reqDealValue === "" ? " Deal Value " : '');
            isOk = 1;
        }
        if (isOk === 0) {
            var obj = {
                srno: props.srno,
                dealId: reqDealId,
                dealRate: reqDealRate,
                dealTenure: reqTenure,
                dealValue: reqDealValue,
                dealValueDate: Common.dateYMD(reqDealValueDate)
            }
            Common.callApi(Common.apiInward, [sid, 'coveradd', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setInwardDetail(resp);
                    setCoverListData(resp.cover);
                    calcTotalCover(resp.cover, resp.data[0]);
                    setReqHeader(resp.data[0]);
                    setReqDealId("");
                    setReqDealRate("");
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                $('.loader').hide();
                setRefreshCounter(refreshCounter + 1);
            });
        }
    }

    function btnDeleteCoverClick(tric_dealno, tric_value) {
        if (reqHeader.reqi_coverfinal === "0" && rightInwardCoverFinal.add === "1") {
            var obj = {
                srno: props.srno,
                dealno: tric_dealno,
                dealvalue: tric_value
            }
            Common.callApi(Common.apiInward, [sid, 'deletecover', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setInwardDetail(resp);
                    setCoverListData(resp.cover);
                    calcTotalCover(resp.cover, resp.data[0]);
                    setReqHeader(resp.data[0]);
                    setReqDealId("");
                    setReqDealRate("");
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                $('.loader').hide();
                setRefreshCounter(refreshCounter + 1);
            });
        }
    }

    function onchangeReqTenure(v) {
        setReqTenure(v);
        const currentDate = new Date();
        const futureDate = new Date(currentDate);

        if (v === "CASH") {
            // futureDate.setDate(currentDate.getDate() + 1);
            futureDate.setDate(currentDate.getDate());
        } else if (v === "TOM") {
            futureDate.setDate(currentDate.getDate() + 1);
        } else if (v === "SPOT") {
            futureDate.setDate(currentDate.getDate() + 2);
        }
        setReqDealValueDate(futureDate);
    }

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                    </Col>
                </Row>
                {
                    refreshCounter > 0 ?
                        <>
                            <Row>
                                <Col>
                                    <InwardView rhdata={inwardDetail} rc={refreshCounter}></InwardView>
                                </Col>
                            </Row>
                        </> : null


                }
                <Row><Col>&nbsp;</Col></Row>
                {
                    reqHeader.reqi_coverfinal === "0" && rightInwardCoverFinal.add === "1" ?
                        <>
                            <Row>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Deal Id<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Deal Id" maxLength={50}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqDealId)}
                                            value={reqDealId} autoComplete="off"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Deal Rate<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Deal Rate" maxLength={10}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqDealRate)}
                                            value={reqDealRate} autoComplete="off"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col>
                                    <Form.Group >
                                        <Form.Label>Deal Value<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Deal Value" maxLength={10}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqDealValue)}
                                            value={reqDealValue} autoComplete="off"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Tenure</Form.Label>
                                        <Form.Select
                                            value={reqTenure}
                                            onChange={(e) => onchangeReqTenure(e.target.value)}
                                        >
                                            <option key="TOM" value="TOM">TOM</option>
                                            <option key="CASH" value="CASH">CASH</option>
                                            <option key="SPOT" value="SPOT">SPOT</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Value Date<span className="mandatory">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={reqDealValueDate}
                                            onChange={(date) => setReqDealValueDate(date)}
                                            isClearable={true}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                                <Col></Col><Col></Col><Col></Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <Button variant="outline-primary" size="sm" onClick={(e) => btnAddCoverClick()} >Add</Button>&nbsp;
                                    <Button variant="outline-primary" size="sm" onClick={(e) => btnCoverFinal()} >Final</Button>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                        </> : null
                }

                <Row>
                    <Col>
                        <h5>Cover List</h5>
                    </Col>
                </Row>
                <Row>
                    <Col>Total Cover Value : {totalCover}&nbsp;&nbsp;Total Cover INR : {totalCoverInr}&nbsp;&nbsp;Avg Rate : {avgCoverRate}</Col>
                </Row>
                <Row>
                    <Col>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    {
                                        reqHeader.reqi_coverfinal === "0" && rightInwardCoverFinal.add === "1" ?
                                            <>
                                                <td></td>
                                            </> : null
                                    }
                                    <td>Issuer</td>
                                    <td>Deal Id</td>
                                    <td>Deal Rate</td>
                                    <td>Deal Value</td>
                                    <td>Deal INR</td>
                                    <td>Value Date</td>
                                    <td>Tenure</td>
                                </tr>
                            </thead>
                            <tbody>

                                {coverListData.map((res) =>
                                    <tr key={res.tric_lineno}>
                                        {
                                            reqHeader.reqi_coverfinal === "0" && rightInwardCoverFinal.add === "1" ? <>
                                                <td>
                                                    <div className="colorThemeBlue">
                                                        <span className="handCursor" onClick={(e) => btnDeleteCoverClick(res.tric_dealno, res.tric_value)}>
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </span>
                                                    </div>
                                                </td>
                                            </> : null
                                        }
                                        <td>{res.tric_bank}&nbsp;:&nbsp;{res.issuer_name}</td>
                                        <td>{res.tric_dealno}</td>
                                        <td>{res.tric_rate}</td>
                                        <td>{res.tric_value}</td>
                                        <td>{(1 * res.tric_value * res.tric_rate).toFixed(2)}</td>
                                        <td>{res.tric_valuedatedmy}</td>
                                        <td>{res.tric_dealtenure}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )

}
export default InwardCover;